const clearCache = () => {
	window.sessionStorage && window.sessionStorage.clear();
	window.localStorage && window.localStorage.clear();
};

export {clearCache};
